import { Component, Inject } from "@angular/core";
import { ConfirmWithRouteDialogData } from "../../../core/models/dialogs/confirm-dialog-data";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ConfirmBase } from "../abstractions/confirm-base.component";

@Component({
  selector: "confirm-with-route",
  templateUrl: "./confirm-with-route.component.html",
  styleUrls: ["./confirm-with-route.component.scss"]
})
export class ConfirmWithRouteDialog extends ConfirmBase {
  constructor(
    public dialogRef: MatDialogRef<ConfirmWithRouteDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmWithRouteDialogData
  ) {
    super(dialogRef, data);
  }

  public openUrl(url?: string): void {
    if (!url) {
      return;
    }

    window.open(url, "_blank");
  }
}
